import { HttpClient, HttpParams } from "@angular/common/http";
import { MenuItem } from "../../layouts/menu.model";
import { AuthService } from "./auth.service";
import { environment } from "src/environments/environment";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { first, map } from "rxjs/operators";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class MenuService {
  private dataSubject$: BehaviorSubject<any>;

  constructor(
    private http: HttpClient,
    private router: Router,
  ) {
    this.dataSubject$ = new BehaviorSubject<any>(null);
  }

  getMenus() {
    return this.http
      .get<MenuItem>(`${environment.apiUrl}/menus`, { withCredentials: true })
      .pipe(
        first(),
        map((data) => this.mapMenuItens(data)),
      );
  }

  checkRoutes(url: string, params: any = null) {
    let httpParams = new HttpParams();
    if (params) {
      Object.entries(params).forEach(([key, val]: any) => {
        httpParams = httpParams.set(`${key}`, val);
      });
    }
    return this.http
      .post<any>(
        `${environment.apiUrl}/menus/check`,
        { url },
        { params: httpParams, withCredentials: true },
      )
      .pipe(first());
  }

  mapMenuItens(data: any): MenuItem[] {
    return data.menus.map((menu: any) => {
      let menuModel: MenuItem = {};
      menuModel.id = menu.id;
      menuModel.label = menu.label;
      menu.isTitle ? (menuModel.isTitle = menu.isTitle) : null;
      menu.icon ? (menuModel.icon = menu.icon) : null;
      menu.link ? (menuModel.link = menu.link) : null;
      // Pill ao lado do nome (ex.: "Beta"); o sidebar já a desenha.
      menu.badge ? (menuModel.badge = menu.badge) : null;
      menuModel.entity_id = menu.entity_id;

      const submenu = data.submenus.filter((submenu: MenuItem) => {
        return submenu.parentId == menu.id;
      });

      if (submenu.length > 0) {
        menuModel.subItems = submenu;

        if (menuModel.link) {
          menuModel.navigate = true;
          menuModel.navigateFromChildren = true;
        }
      }

      return menuModel;
    });
  }

  /**
   * Abre o quadro de negócios certo para este utilizador, com o alvo no
   * `setData`: o funil (/deals) quando o backend o autoriza; senão a lista
   * antiga (/deals/board — beta do funil, `FUNNEL_BETA_ROLES` no back-end).
   * Os dois ecrãs consomem o mesmo payload ao carregar. Sem beta ativo o
   * backend autoriza /deals a quem sempre o teve e isto navega como dantes.
   */
  openDealsBoard(payload: any) {
    this.setData(payload);
    this.checkRoutes("/deals").subscribe({
      next: () => this.router.navigate(["/deals"]),
      error: () => this.router.navigate(["/deals/board"]),
    });
  }

  setData(data: any) {
    this.dataSubject$.next(data);
  }

  getData() {
    return this.dataSubject$.value;
  }
}
